const body = document.querySelector('body');
const header = document.querySelector('header');
const secondaryMenu = document.querySelector('.secondary-menu');
const headerBanner = document.querySelector('.header__banner');

// Sticky header stuff
const stickyHeaderOffset = 400;

if (secondaryMenu) {
  body.classList.add('has--secondary-menu');
}

if (header) {
  body.classList.add('has--main-menu');
}

if (headerBanner) {
  body.classList.add('has--header-banner');
}

if (document.scrollingElement.scrollTop == 0) {
  body.classList.add('is--at-top');
}

document.addEventListener('scroll', () => {
  var scrolled = document.scrollingElement.scrollTop;
  var position = body.offsetTop;

  if (scrolled < stickyHeaderOffset) {
    body.classList.add('is--at-top');
  } else {
    // No sticky header if 'Shop' listing page as requested by client
    if (!body.querySelector('.product-grid-container > #product-grid')) {
      body.classList.remove('is--at-top');
    }
  }

  if (scrolled > position + stickyHeaderOffset) {
    // No sticky header if 'Shop' listing page as requested by client
    if (!body.querySelector('.product-grid-container > #product-grid')) {
      body.classList.add('has--scrolled');
    }
  } else {
    body.classList.remove('has--scrolled');
  }
});

let lastScrollTop = 0;

document.addEventListener('scroll', () => {
  var scrolled = document.scrollingElement.scrollTop;

  if (scrolled < lastScrollTop) {
    // No sticky header if 'Shop' listing page as requested by client
    if (scrolled >= stickyHeaderOffset) {
      if (!body.querySelector('.product-grid-container > #product-grid')) {
        body.classList.add('is--scrolling-up');
      }
    } else {
      body.classList.remove('is--scrolling-up');
    }
    body.classList.remove('is--scrolling-down');
  } else {
    if (scrolled >= stickyHeaderOffset) {
      // No sticky header if 'Shop' listing page as requested by client
      if (!body.querySelector('.product-grid-container > #product-grid')) {
        body.classList.add('is--scrolling-down');
      }
    } else {
      body.classList.remove('is--scrolling-down');
    }

    body.classList.remove('is--scrolling-up');
  }

  lastScrollTop = scrolled;
});

// Mobile menu stuff
const mainMenu = document.querySelector('.header-nav__menu');
const mobileMenuOpen = document.querySelector('.header-nav__mobile-menu');
const menuItemsWithChildren = header.querySelectorAll('.menu__link.has-childlinks');
const accountButton = header.querySelector('.header__icon--account');
const newDiv = document.createElement('div');
const breakpoint = 1200;

menuItemsWithChildren.forEach((item) => {
  const menuLink = item.querySelector('.link-wrapper');
  const subMenu = item.querySelector('.header-nav__sub-menu .sub-menu-list');
  var contentHeight = subMenu.scrollHeight;

  menuLink.addEventListener('click', (e) => {
    item.parentElement.querySelectorAll('.is--open').forEach((openItem) => {
      const subMenu = openItem.querySelector('.header-nav__sub-menu .sub-menu-list');
      if (openItem != item) {
        openItem.classList.remove('is--open');
        subMenu.style.height = '0px';
      }
    });

    if (item.classList.contains('is--open')) {
      item.classList.remove('is--open');
      subMenu.style.height = '0px';
    } else {
      item.classList.add('is--open');
      subMenu.style.height = contentHeight + 'px';
    }
  });
});

window.addEventListener('resize', () => {
  checkWindowWidth();
});

mobileMenuOpen.addEventListener('click', () => {
  if (body.classList.contains('mobile-menu--open')) {
    closeMobileMenu();
  } else {
    openMobileMenu();
  }
});

function openMobileMenu() {
  body.classList.add('mobile-menu--open');
  header.classList.add('mobile-menu--open');

  newDiv.classList.add('secondary-menu');
  mainMenu.appendChild(newDiv);

  if (secondaryMenu) {
    const secondaryMenuContent = secondaryMenu.querySelector('.menu').innerHTML;
    newDiv.innerHTML = secondaryMenuContent;
  }

  if (accountButton) {
    const accountButtonContent = accountButton.cloneNode(true);
    newDiv.appendChild(accountButtonContent);
  }
}

function closeMobileMenu() {
  if (body.classList.contains('mobile-menu--open')) {
    body.classList.remove('mobile-menu--open');
    header.classList.remove('mobile-menu--open');
    newDiv.remove();
  }
}

function checkWindowWidth() {
  if (window.innerWidth <= breakpoint) {
    body.classList.remove('has--secondary-menu');
    body.classList.remove('has--header-banner');
  } else {
    closeMobileMenu();
  }
}

checkWindowWidth();
